import { formatNameFirstLast, sortAsc } from '@strata/helper-functions';
import { DialogWithForm } from '@strata/react-dialog';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { useUserProfile } from 'services/APIHooks';
import { useGetUsersQuery } from 'store/api/userSupportApi';

const unassignedUser = {
    name: 'Unassigned',
    upn: null,
};

export const ChangeConversationAssignmentDialog = ({
    isOpen = false,
    onChangeAssignment,
    currentAssigneeUpn = undefined,
    onCancel,
}) => {
    const { data: users } = useGetUsersQuery();
    const { userProfile } = useUserProfile();
    const { upn: currentUserUpn } = userProfile;

    const usersList = [
        unassignedUser,
        {
            name: 'Assign to Me',
            upn: currentUserUpn,
        },
        ...(users ?? [])
            .filter(({ upn }) => currentUserUpn !== upn)
            .map((user) => ({
                name: formatNameFirstLast(user.first_name, user.last_name),
                ...user,
            }))
            .sort(({ name: a }, { name: b }) => sortAsc(a, b)),
    ];

    return (
        <Formik
            initialValues={{
                assignee:
                    usersList.find((user) => user.upn === currentAssigneeUpn) ?? unassignedUser,
            }}
            onSubmit={(values, { resetForm }) => {
                onChangeAssignment(values);
                resetForm();
            }}
            validationSchema={Yup.object({
                assignee: Yup.object({}).required(validationStrings.requiredField.errorMessage),
            })}
            enableReinitialize
        >
            {(formik) => (
                <DialogWithForm
                    isOpen={isOpen}
                    dialogTitle="Select/Change Assignment"
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    onSecondaryButtonClick={() => {
                        onCancel();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Assign Conversation"
                    secondaryButtonLabel="Cancel"
                    dialogContent={
                        <SuggestSingleSelectFormik
                            id="assignee"
                            label="Assignment"
                            required
                            values={usersList}
                        />
                    }
                />
            )}
        </Formik>
    );
};

ChangeConversationAssignmentDialog.propTypes = {
    isOpen: PropTypes.bool,
    onChangeAssignment: PropTypes.func.isRequired,
    currentAssigneeUpn: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
};
